<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted () {
    if (this._isMobile()) {
      // this.$router.replace('/')
      // this.$router.replace('/service')
    } else {
      // document.getElementById('app').style.height = document.body.clientHeight * 0.5 + 'px'
      // document.getElementsByTagName('html')[0].style.height = 'auto'
      // document.getElementsByTagName('body')[0].style.height = 'auto'
      // this.$router.replace('/pcLogin')
      // this.$router.replace('/pcService')
      // this.$router.replace('/service')
    }
  },
  methods: {
    _isMobile () {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>

<style lang="less">
html,
body {
  width: 100%;
  /*height: 100%;*/
  height: auto;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%; // pc
  /*height: calc(100% - 40px); // app*/
  margin-top: 1px; // app打包时注释掉
}
</style>
